import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { TeachUnit } from '@api/model/basic-data/TeachUnit'
import store from '@/store'
import { ResponseStatus } from '@api/Response'
import PlatformBasicData from '@api/gateway/PlatformBasicData'

interface BasicDataState {
  // 当前选择的单位
  currentUnit: TeachUnit
  subProjectUnitId: string
}

@Module({ namespaced: true, dynamic: true, store, name: 'CustomerBasicDataModule' })
class CustomerBasicDataModule extends VuexModule implements BasicDataState {
  currentUnit: TeachUnit = new TeachUnit()
  subProjectUnitId = ''

  @Action
  async getCurrentUnitByDomain(params: { domain: string; subUnitId: string }): Promise<ResponseStatus> {
    if (this.currentUnit && this.currentUnit.id) {
      return new ResponseStatus(200, '')
    }
    const response = await PlatformBasicData.findTeachUnitByDomain(params.domain)
    if (response.status.isSuccess()) {
      const unitDetails: TeachUnit = new TeachUnit()
      if (response.data) {
        unitDetails.mobileShow = response.data.mobileShow
        unitDetails.wxShow = response.data.wxShow
        unitDetails.id = response.data.unitId
        unitDetails.name = response.data.name
        unitDetails.organizationCode = response.data.organizationCode
        unitDetails.provinceId = response.data.provinceId
        unitDetails.cityId = response.data.cityId
        unitDetails.countyId = response.data.countyId
        unitDetails.status = response.data.status
        unitDetails.portalName = response.data.portalName
        unitDetails.logoUrl = response.data.logoUrl
        unitDetails.bannerUrls = response.data.bannerUrls
        unitDetails.portalFooterDescribe = response.data.portalFooterDescribe
        unitDetails.onlineCustomerInfo = response.data.onlineCustomerInfo
        unitDetails.customerPhone = response.data.customerPhone
      }
      if (unitDetails.id === params.subUnitId) {
        this.SET_SUB_PROJECT_UNIT_ID(unitDetails.id)
      }
      this.SET_CURRENT_UNIT(unitDetails)
    }
    return response.status
  }

  @Action
  setCurrentUnit(data: TeachUnit) {
    this.SET_CURRENT_UNIT(data)
  }
  @Mutation
  SET_CURRENT_UNIT(teachUnit: TeachUnit) {
    this.currentUnit = teachUnit
  }

  @Mutation
  SET_SUB_PROJECT_UNIT_ID(id: string) {
    this.subProjectUnitId = id
  }
}

export default getModule(CustomerBasicDataModule)
